// import { initializeApp } from "firebase/app";

// const firebaseConfig = {
//   apiKey: "YOUR_API_KE",
//   authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
//   projectId: "YOUR_PROJECT_ID",
//   appId: "YOUR_APP_ID",
// };

// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);








// // Import the functions you need from the SDKs you need
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";

// import { initializeApp } from "firebase/app";
// import { getFunctions } from "firebase/functions";


// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyD86Kx8trgGchbZ0OB-KXD7Rz_JifXl4ME",
//   authDomain: "prooftap-f7ca4.firebaseapp.com",
//   projectId: "prooftap-f7ca4",
//   storageBucket: "prooftap-f7ca4.firebasestorage.app",
//   messagingSenderId: "477761567616",
//   appId: "1:477761567616:web:21bfb4adf19da11c085f65",
//   measurementId: "G-9KK8MDTLW5"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// export const db = getFirestore(app); // ✅ REQUIRED
// export const functions = getFunctions(app, "us-central1");























import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD86Kx8trgGchbZ0OB-KXD7Rz_JifXl4ME",
  authDomain: "prooftap-f7ca4.firebaseapp.com",
  projectId: "prooftap-f7ca4",
  storageBucket: "prooftap-f7ca4.appspot.com",
  messagingSenderId: "477761567616",
  appId: "1:477761567616:web:21bfb4adf19da11c085f65",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * 🔴 DO NOT pass region here
 * 🔴 DO NOT create another functions instance anywhere else
 */
export const functions = getFunctions(app);
